var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-wrapper1 bhxc-bg",
      class: { hideSidebar: !_vm.sidebar.opened },
      attrs: { id: "slxc" }
    },
    [
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c("div", { staticClass: "header" }, [
              _c("div", { staticClass: "header-left" }),
              _c("div", { staticClass: "header-right" }, [
                _c(
                  "span",
                  {
                    staticClass: "Backstage",
                    staticStyle: {
                      "line-height": "3.5vh",
                      height: "3.5vh",
                      display: "flex"
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "0.8vw",
                          padding: "0.5vh 0.6vw"
                        }
                      },
                      [_vm._v("欢迎您! " + _vm._s(this.userName))]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "out",
                        staticStyle: {
                          cursor: "pointer",
                          "margin-right": "1vh",
                          padding: "0.5vh 0"
                        },
                        on: { click: _vm.manage }
                      },
                      [
                        _c("img", {
                          staticStyle: {
                            cursor: "pointer",
                            width: "1vw",
                            height: "1vw"
                          },
                          attrs: {
                            src: "/web/static/img/overview/backstage.png"
                          }
                        })
                      ]
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          cursor: "pointer",
                          "margin-right": "1vh",
                          padding: "0.5vh 0"
                        },
                        on: { click: _vm.logout }
                      },
                      [
                        _c("img", {
                          staticStyle: {
                            cursor: "pointer",
                            width: "1vw",
                            height: "1vw"
                          },
                          attrs: { src: "/web/static/img/overview/layout.png" }
                        })
                      ]
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          cursor: "pointer",
                          "margin-right": "1vh",
                          padding: "0.5vh 0"
                        },
                        on: { click: _vm.getFullCreeen }
                      },
                      [
                        _c("img", {
                          staticStyle: {
                            cursor: "pointer",
                            width: "1vw",
                            height: "1vw"
                          },
                          attrs: {
                            src: "/web/static/img/overview/fullscreen.png"
                          }
                        })
                      ]
                    )
                  ]
                )
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "bhxcsq-new-dashboard-table",
          staticStyle: { padding: "0 10px", margin: "1.5vh 2vh 4vh 2vh" }
        },
        [
          _c(
            "el-col",
            { staticStyle: { height: "100%" }, attrs: { span: 7 } },
            [
              _c("div", { staticClass: "left" }, [
                _c("div", [
                  _c("div", { staticClass: "xin-title" }, [
                    _c("div", { staticClass: "xin-title-img" }, [
                      _c("img", {
                        attrs: { src: "/static/xindaping/baoxiu.png", alt: "" }
                      })
                    ])
                  ]),
                  _c("div", { staticClass: "moduleContainer" }, [
                    _c(
                      "div",
                      [
                        _c(
                          "el-row",
                          [
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c(
                                "div",
                                { staticClass: "warrantyChart-box" },
                                [
                                  _c("warrantyChart", {
                                    attrs: {
                                      chartData: _vm.chartData1,
                                      lendName: _vm.lendName1,
                                      total: _vm.total1
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _c("el-col", { attrs: { span: 16 } }, [
                              _c("div", { staticClass: "flex-align" }, [
                                _c(
                                  "div",
                                  { staticClass: "press" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "title flex-sb mg-bm-5" },
                                      [
                                        _c("div", [_vm._v("未处理")]),
                                        _c("div", [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.untreatedCount) +
                                              "%(" +
                                              _vm._s(
                                                _vm.statisticsWarranty
                                                  .untreatedCount
                                              ) +
                                              ") "
                                          )
                                        ])
                                      ]
                                    ),
                                    _c("el-progress", {
                                      attrs: {
                                        "show-text": false,
                                        "stroke-width": 12,
                                        percentage: _vm.untreatedCount,
                                        color: _vm.customColor2
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "press" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "title flex-sb mg-bm-5" },
                                      [
                                        _c("div", [_vm._v("已处理")]),
                                        _c("div", [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.processedCount) +
                                              "%(" +
                                              _vm._s(
                                                _vm.statisticsWarranty
                                                  .processedCount
                                              ) +
                                              ") "
                                          )
                                        ])
                                      ]
                                    ),
                                    _c("el-progress", {
                                      attrs: {
                                        "show-text": false,
                                        "stroke-width": 12,
                                        percentage: _vm.processedCount,
                                        color: _vm.customColor
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _c("div", [
                  _c("div", { staticClass: "xin-title" }, [
                    _c("div", { staticClass: "xin-title-img" }, [
                      _c("img", {
                        attrs: { src: "/static/xindaping/manyi.png", alt: "" }
                      })
                    ])
                  ]),
                  _c("div", { staticClass: "moduleContainer1" }, [
                    _c(
                      "div",
                      { staticClass: "bhxcsq-new-dashboard-table table1" },
                      [
                        _c(
                          "el-table",
                          {
                            staticStyle: {
                              width: "100%",
                              height: "24.8vh",
                              overflow: "hidden"
                            },
                            attrs: { data: _vm.surveyCount, size: "small" }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "surveyTitle",
                                label: "问卷标题",
                                "show-overflow-tooltip": ""
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "surveyStatus",
                                label: "状态",
                                "show-overflow-tooltip": ""
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "shouldAnswerNum",
                                label: "应填人数",
                                "show-overflow-tooltip": ""
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "alreadyAnswerNum",
                                label: "实填人数",
                                "show-overflow-tooltip": ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _c("div", [
                  _c("div", { staticClass: "xin-title" }, [
                    _c("div", { staticClass: "xin-title-img" }, [
                      _c("img", {
                        attrs: { src: "/static/xindaping/tousu.png", alt: "" }
                      })
                    ])
                  ]),
                  _c("div", { staticClass: "moduleContainer2" }, [
                    _c(
                      "div",
                      { staticClass: "complaints-chart" },
                      [
                        _c("complaintsChart", {
                          attrs: {
                            chartData: _vm.chartData2,
                            xAxisData: _vm.lendName2
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ])
            ]
          ),
          _c(
            "el-col",
            {
              staticStyle: { height: "100%", "padding-left": "10px" },
              attrs: { span: 10 }
            },
            [
              _c(
                "div",
                { staticClass: "query flex-sb" },
                [
                  _c("div", { staticClass: "aside-title" }, [
                    _vm._v("小区名称")
                  ]),
                  _c(
                    "el-select",
                    {
                      staticClass: "form-item-width",
                      staticStyle: { width: "240px" },
                      attrs: { multiple: "" },
                      on: { change: _vm.handleFilter },
                      model: {
                        value: _vm.listQuery.communityIds,
                        callback: function($$v) {
                          _vm.$set(_vm.listQuery, "communityIds", $$v)
                        },
                        expression: "listQuery.communityIds"
                      }
                    },
                    _vm._l(_vm.buildList, function(item) {
                      return _c("el-option", {
                        key: item.communityId.toString(),
                        attrs: {
                          label: item.communityName,
                          value: item.communityId.toString()
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c("div", [
                _c("div", { staticClass: "xin-title1" }, [
                  _c("div", { staticClass: "xin-title-img" }, [
                    _c("img", {
                      attrs: { src: "/static/xindaping/zulin.png", alt: "" }
                    })
                  ])
                ]),
                _c("div", { staticClass: "moduleContainer3" }, [
                  _c("div", { staticClass: "housing-content" }, [
                    _c(
                      "div",
                      {
                        staticClass: "card inRentCount-bg",
                        class: {
                          pointerIsDisable: _vm.bannerMenuIdList[3].isDisable
                        },
                        attrs: {
                          title: _vm.bannerMenuIdList[3].isDisable
                            ? "请联系楼宇管理员开通相应功能菜单"
                            : ""
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleMenuSelect(
                              _vm.bannerMenuIdList[3],
                              {
                                tab: "third",
                                Status: "houseCount"
                              }
                            )
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "card-wrapper" }, [
                          _c("div", { staticStyle: { height: "10vh" } }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  position: "absolute",
                                  top: "-1vh",
                                  left: "2vh"
                                }
                              },
                              [
                                _c("img", {
                                  staticStyle: {
                                    height: "12vh",
                                    width: "12vh"
                                  },
                                  attrs: {
                                    src: "/static/xindaping/box1.png",
                                    alt: ""
                                  }
                                })
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "num",
                                staticStyle: {
                                  position: "absolute",
                                  top: "2.5vh",
                                  right: "4vh"
                                }
                              },
                              [_vm._v(_vm._s(this.houseCount.houseCount))]
                            )
                          ]),
                          _c("div", { staticClass: "title" }, [
                            _vm._v("可租赁房屋总数")
                          ])
                        ])
                      ]
                    ),
                    _c("div", { staticClass: "card inRentCount-bg" }, [
                      _c(
                        "div",
                        {
                          staticClass: "card-wrapper",
                          class: {
                            pointerIsDisable: _vm.bannerMenuIdList[3].isDisable
                          },
                          attrs: {
                            title: _vm.bannerMenuIdList[3].isDisable
                              ? "请联系楼宇管理员开通相应功能菜单"
                              : ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleMenuSelect(
                                _vm.bannerMenuIdList[3],
                                { tab: "third", Status: "inRentCount" }
                              )
                            }
                          }
                        },
                        [
                          _c("div", { staticStyle: { height: "10vh" } }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  position: "absolute",
                                  top: "-1vh",
                                  left: "2vh"
                                }
                              },
                              [
                                _c("img", {
                                  staticStyle: {
                                    height: "12vh",
                                    width: "12vh"
                                  },
                                  attrs: {
                                    src: "/static/xindaping/box2.png",
                                    alt: ""
                                  }
                                })
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "num",
                                staticStyle: {
                                  position: "absolute",
                                  top: "2.5vh",
                                  right: "4vh"
                                }
                              },
                              [_vm._v(_vm._s(this.houseCount.inRentCount))]
                            )
                          ]),
                          _c("div", { staticClass: "title" }, [
                            _vm._v("在租房间")
                          ])
                        ]
                      )
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "card inRentCount-bg",
                        class: {
                          pointerIsDisable: _vm.bannerMenuIdList[3].isDisable
                        },
                        attrs: {
                          title: _vm.bannerMenuIdList[3].isDisable
                            ? "请联系楼宇管理员开通相应功能菜单"
                            : ""
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleMenuSelect(
                              _vm.bannerMenuIdList[3],
                              {
                                tab: "third",
                                Status: "vacantCount"
                              }
                            )
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "card-wrapper" }, [
                          _c("div", { staticStyle: { height: "10vh" } }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  position: "absolute",
                                  top: "-1vh",
                                  left: "2vh"
                                }
                              },
                              [
                                _c("img", {
                                  staticStyle: {
                                    height: "12vh",
                                    width: "12vh"
                                  },
                                  attrs: {
                                    src: "/static/xindaping/box2.png",
                                    alt: ""
                                  }
                                })
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "num",
                                staticStyle: {
                                  position: "absolute",
                                  top: "2.5vh",
                                  right: "4vh"
                                }
                              },
                              [_vm._v(_vm._s(this.houseCount.vacantCount))]
                            )
                          ]),
                          _c("div", { staticClass: "title" }, [
                            _vm._v("空置房间")
                          ])
                        ])
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "card inRentCount-bg",
                        class: {
                          pointerIsDisable: _vm.bannerMenuIdList[2].isDisable
                        },
                        attrs: {
                          title: _vm.bannerMenuIdList[2].isDisable
                            ? "请联系楼宇管理员开通相应功能菜单"
                            : ""
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleMenuSelect(
                              _vm.bannerMenuIdList[2],
                              { tab: "1" }
                            )
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "card-wrapper" }, [
                          _c("div", { staticStyle: { height: "10vh" } }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  position: "absolute",
                                  top: "-1vh",
                                  left: "2vh"
                                }
                              },
                              [
                                _c("img", {
                                  staticStyle: {
                                    height: "12vh",
                                    width: "12vh"
                                  },
                                  attrs: {
                                    src: "/static/xindaping/box3.png",
                                    alt: ""
                                  }
                                })
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "num",
                                staticStyle: {
                                  position: "absolute",
                                  top: "2.5vh",
                                  right: "4vh"
                                }
                              },
                              [_vm._v(_vm._s(this.houseCount.newSigningCount))]
                            )
                          ]),
                          _c("div", { staticClass: "title" }, [
                            _vm._v("合同总数")
                          ])
                        ])
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "card inRentCount-bg",
                        class: {
                          pointerIsDisable: _vm.bannerMenuIdList[2].isDisable
                        },
                        attrs: {
                          title: _vm.bannerMenuIdList[2].isDisable
                            ? "请联系楼宇管理员开通相应功能菜单"
                            : ""
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleMenuSelect(
                              _vm.bannerMenuIdList[2],
                              { tab: "4" }
                            )
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "card-wrapper" }, [
                          _c("div", { staticStyle: { height: "10vh" } }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  position: "absolute",
                                  top: "-1vh",
                                  left: "2vh"
                                }
                              },
                              [
                                _c("img", {
                                  staticStyle: {
                                    height: "12vh",
                                    width: "12vh"
                                  },
                                  attrs: {
                                    src: "/static/xindaping/box2.png",
                                    alt: ""
                                  }
                                })
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "num",
                                staticStyle: {
                                  position: "absolute",
                                  top: "2.5vh",
                                  right: "4vh"
                                }
                              },
                              [_vm._v(_vm._s(this.houseCount.expireCount))]
                            )
                          ]),
                          _c("div", { staticClass: "title" }, [
                            _vm._v("到期合同")
                          ])
                        ])
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "card inRentCount-bg",
                        class: {
                          pointerIsDisable: _vm.bannerMenuIdList[2].isDisable
                        },
                        attrs: {
                          title: _vm.bannerMenuIdList[2].isDisable
                            ? "请联系楼宇管理员开通相应功能菜单"
                            : ""
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleMenuSelect(
                              _vm.bannerMenuIdList[2],
                              { tab: "6" }
                            )
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "card-wrapper" }, [
                          _c("div", { staticStyle: { height: "10vh" } }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  position: "absolute",
                                  top: "-1vh",
                                  left: "2vh"
                                }
                              },
                              [
                                _c("img", {
                                  staticStyle: {
                                    height: "12vh",
                                    width: "12vh"
                                  },
                                  attrs: {
                                    src: "/static/xindaping/box2.png",
                                    alt: ""
                                  }
                                })
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "num",
                                staticStyle: {
                                  position: "absolute",
                                  top: "2.5vh",
                                  right: "4vh"
                                }
                              },
                              [_vm._v(_vm._s(this.houseCount.throwLeaseCount))]
                            )
                          ]),
                          _c("div", { staticClass: "title" }, [
                            _vm._v("退租合同")
                          ])
                        ])
                      ]
                    )
                  ])
                ])
              ]),
              _c("div", [
                _c("div", { staticClass: "xin-title1" }, [
                  _c("div", { staticClass: "xin-title-img" }, [
                    _c("img", {
                      attrs: { src: "/static/xindaping/qianfei.png", alt: "" }
                    })
                  ])
                ]),
                _c("div", { staticClass: "moduleContainer4" }, [
                  _c("div", { staticClass: "flex-sb" }, [
                    _c("div", [
                      _c(
                        "div",
                        {
                          staticClass: "picker-date",
                          staticStyle: { margin: "1vh 0 0 1vh" }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "280px" },
                            attrs: {
                              "popper-class": _vm.customClass,
                              type: "daterange",
                              "range-separator": "至",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期"
                            },
                            on: { change: _vm.lackChooseData },
                            model: {
                              value: _vm.dates,
                              callback: function($$v) {
                                _vm.dates = $$v
                              },
                              expression: "dates"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "lack-content flex-sb" }, [
                    _c(
                      "div",
                      { staticClass: "lack-statistical-chart" },
                      [
                        _c("lackStatisticalChart", {
                          attrs: {
                            chartData: _vm.chartData3,
                            lendName: _vm.lendName3,
                            total: _vm.total3
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "bhxcsq-new-dashboard-table table1" },
                      [
                        _c(
                          "el-table",
                          {
                            staticStyle: { width: "22vw", height: "33vh" },
                            attrs: {
                              data: _vm.recodeOutCount.recodeCountDetails,
                              size: "small"
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "chargeName",
                                label: "收费项目",
                                "show-overflow-tooltip": ""
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "receivableAmount",
                                label: "应收",
                                width: "110"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "paidAmount",
                                label: "实收",
                                "show-overflow-tooltip": ""
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "unpaidAmount",
                                label: "欠费",
                                "show-overflow-tooltip": ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ])
              ])
            ]
          ),
          _c(
            "el-col",
            { staticStyle: { height: "100%" }, attrs: { span: 7 } },
            [
              _c("div", [
                _c("div", { staticClass: "xin-title" }, [
                  _c("div", { staticClass: "xin-title-img" }, [
                    _c("img", {
                      attrs: { src: "/static/xindaping/tongzhi.png", alt: "" }
                    })
                  ])
                ]),
                _c("div", { staticClass: "moduleContainer5" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "notice-content bhxcsq-new-dashboard-table table1"
                    },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%", height: "21vh" },
                          attrs: {
                            data: _vm.noticeList,
                            "show-header": false,
                            size: "small"
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              label: "标题",
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", {}, [
                                      _vm._v(_vm._s(scope.row.title))
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              label: "时间",
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.publishDate))
                                    ])
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]),
              _c("div", { staticClass: "xin-title" }, [
                _c("div", { staticClass: "xin-title-img" }, [
                  _c("img", {
                    attrs: { src: "/static/xindaping/hetong.png", alt: "" }
                  })
                ])
              ]),
              _c("div", { staticClass: "moduleContainer6" }, [
                _c("div", { staticClass: "flex-sb" }, [
                  (this.userType === 32 || this.userType === 16) &&
                  !_vm.bannerMenuIdList[2].isDisable
                    ? _c(
                        "span",
                        {
                          staticClass: "more",
                          on: {
                            click: function($event) {
                              return _vm.handleMenuSelect(
                                _vm.bannerMenuIdList[2]
                              )
                            }
                          }
                        },
                        [_vm._v(" 更多 ")]
                      )
                    : _c(
                        "span",
                        {
                          staticClass: "more",
                          class: { none: _vm.bannerMenuIdList[2].isDisable },
                          on: {
                            click: function($event) {
                              return _vm.handleMenuSelect(
                                _vm.bannerMenuIdList[2]
                              )
                            }
                          }
                        },
                        [_vm._v(" 更多 ")]
                      )
                ]),
                _c(
                  "div",
                  { staticClass: "contract-early-warning-chart" },
                  [
                    _c("earlyWarningChart", {
                      attrs: {
                        chartData: _vm.chartData4,
                        lendName: _vm.lendName4
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "contract-early-warning-table bhxcsq-new-dashboard-table table1"
                  },
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: {
                          width: "100%",
                          height: "28vh",
                          "margin-top": "2vh"
                        },
                        attrs: {
                          data: _vm.leaseContractCountList,
                          size: "small"
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "contractNo",
                            label: "合同编号",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "contractName",
                            label: "合同名称",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "customerName",
                            label: "租户名称",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "endDate",
                            label: "到期时间",
                            width: "100"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }